var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.1172,
    r: 9.5,
    stroke: "#6927DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8247 13.9414C11.9242 15.8419 9.76488 17.0893 7.82989 17.5869C5.88233 18.0877 4.26051 17.8123 3.28235 16.8341C2.3042 15.856 2.02877 14.2342 2.52957 12.2866C3.02714 10.3516 4.27457 8.19231 6.17506 6.29181C8.07556 4.39131 10.2349 3.14388 12.1698 2.64631C14.1174 2.14551 15.7392 2.42094 16.7174 3.3991C17.6955 4.37725 17.971 5.99908 17.4702 7.94664C16.9726 9.88163 15.7252 12.0409 13.8247 13.9414Z",
    stroke: "#6927DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8242 6.28665C15.7247 8.18715 16.9722 10.3464 17.4697 12.2814C17.9705 14.229 17.6951 15.8508 16.7169 16.829C15.7388 17.8071 14.117 18.0826 12.1694 17.5818C10.2344 17.0842 8.07512 15.8368 6.17462 13.9363C4.27412 12.0358 3.0267 9.87647 2.52913 7.94148C2.02833 5.99392 2.30376 4.3721 3.28191 3.39395C4.26007 2.41579 5.88189 2.14036 7.82945 2.64116C9.76444 3.13873 11.9237 4.38616 13.8242 6.28665Z",
    stroke: "#6927DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany05);
export default __webpack_public_path__ + "static/media/company-05.65071b851516f7386328ab4a6bd5aa1c.svg";
export { ForwardRef as ReactComponent };